import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Card,
  CardMedia,
  Typography,
} from "@mui/material";
import { UseGeneralPages } from "../../UseGeneralPages";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../../../components/ProgressCom";
import Detail from "../../../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { FileUploader } from "react-drag-drop-files";
import EditPageContentImages from "./EditPageContentImages";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function AddPageContent() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { UpdatePageContent, validateContent } = UseGeneralPages();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [state, setState] = useState({
    title: undefined,
    content: undefined,
    generalID: undefined,
  });
  const { isSmall } = useBreakpoints();

  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [imgState, setImgState] = useState({
    file: undefined,
    url: "",
  });

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  const [errorState, setErrorState] = useState({
    title: false,
    content: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/generalpages" },
          {
            name: "ویرایش صفحه",
            url: "/generalpages/pageDetail",
            targetID: location.state.id,
            scrollTo: location.state.scrollTo,
          },
          {
            name: "افزودن محتوای صفحه",
            url: "/generalpages/pageDetail/addPageContent",
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span  4"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  title: evt.target.value,
                  generalID: location.state.id,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span  5"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Typography variant="subtitle2" sx={{ mr: 1 }}>
              آیکن :
            </Typography>
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "80px", height: "auto" }}>
                  <Card
                    sx={{
                      p: 1,
                      border: "2px dashed #0073E7",
                      borderRadius: 4,
                      boxShadow: 0,
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url
                          ? imgState.url
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              متن :
            </Typography>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              style={{ width: "100%" }}
              data={state.content ? state.content : ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                setState({ ...state, content: data });
              }}
              error={errorState.content}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "400px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span  6"}>
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              تصاویر متن :
            </Typography>
            <EditPageContentImages
              GeneralID={location.state && location.state.id}
              data={location.state ? location.state.images : []}
            />
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validateContent(state, setErrorState) == 200) {
                  setProgress(true);
                  UpdatePageContent(state, imgState.file, () => {
                    navigate("/generalpages/pageDetail", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/generalpages/pageDetail", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
